<template>
  <button
    :class="[
      'font-heading font-semibold rounded-xl focus:outline-none transition-all duration-200 flex items-center justify-center gap-2 transform hover:scale-105 focus:ring-4 focus:ring-opacity-50',
      sizeClass,
      variantClass,
      focusRingClass,
      loading ? 'opacity-70 cursor-not-allowed hover:scale-100' : '',
      disabled ? 'opacity-60 cursor-not-allowed hover:scale-100' : ''
    ]"
    :disabled="loading || disabled"
    @click="$emit('click', $event)"
  >
    <Spinner v-if="loading" class="w-4 h-4 animate-spin" />
    <slot />
  </button>
</template>
<script>
import Spinner from './Spinner.vue';
export default {
  name: 'BaseButton',
  components: { Spinner },
  props: {
    variant: {
      type: String,
      default: 'primary',
      validator: v => ['primary', 'secondary', 'accent', 'success', 'warning', 'info', 'danger'].includes(v)
    },
    size: {
      type: String,
      default: 'md',
      validator: v => ['sm', 'md', 'lg'].includes(v)
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    variantClass() {
      switch (this.variant) {
        case 'secondary':
          return 'bg-gradient-to-r from-secondary to-secondary-dark text-white hover:from-secondary-dark hover:to-secondary shadow-lg hover:shadow-xl';
        case 'accent':
          return 'bg-gradient-accent text-anthracite-dark hover:from-accent-dark hover:to-accent shadow-lg hover:shadow-xl';
        case 'success':
          return 'bg-gradient-success text-white hover:from-success-dark hover:to-success shadow-lg hover:shadow-xl';
        case 'warning':
          return 'bg-gradient-warning text-white hover:from-warning-dark hover:to-warning shadow-lg hover:shadow-xl';
        case 'info':
          return 'bg-info hover:bg-info-dark text-white shadow-lg hover:shadow-xl';
        case 'danger':
          return 'bg-danger hover:bg-danger-dark text-white shadow-lg hover:shadow-xl';
        default:
          return 'bg-gradient-primary text-white hover:from-primary-dark hover:to-primary shadow-lg hover:shadow-xl';
      }
    },
    sizeClass() {
      switch (this.size) {
        case 'sm':
          return 'px-4 py-2 text-sm';
        case 'lg':
          return 'px-8 py-4 text-lg';
        default:
          return 'px-6 py-3 text-base';
      }
    },
    focusRingClass() {
      switch (this.variant) {
        case 'secondary':
          return 'focus:ring-secondary';
        case 'accent':
          return 'focus:ring-accent';
        case 'success':
          return 'focus:ring-success';
        case 'warning':
          return 'focus:ring-warning';
        case 'info':
          return 'focus:ring-info';
        case 'danger':
          return 'focus:ring-danger';
        default:
          return 'focus:ring-primary';
      }
    }
  }
};
</script>

